import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import React, { useEffect, useState } from "react";
import PendingRequests from "./PendingRequests";
import { useLocation, useParams } from "react-router-dom";
import {
  get_admin_stripe_setting,
  get_payment_request_details,
} from "../../DAL/PaymentRequest/paymentRequest";
import CircularLoader from "../../components/loader/CircularLoader";

export default function PendingRequestsPayment() {
  const { state } = useLocation();
  const params = useParams();
  const [loading, setLoading] = useState(true);
  const [key, setKey] = useState("");
  const [paymentRequestDetails, setPaymentRequestDetails] = useState();

  const getRequestDetail = async () => {
    const result = await get_payment_request_details(params.id);
    if (result.code === 200) {
      setPaymentRequestDetails(result.payment_request);
    }
  };
  const getStripeSetting = async () => {
    const result = await get_admin_stripe_setting();
    if (result.code === 200) {
      if (result.stripe_setting.stripe_mode == "sandBox") {
        setKey(result.stripe_setting.sandBox_publish_key);
      } else {
        setKey(result.stripe_setting.live_publish_key);
      }
    }
  };
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const promises = [getStripeSetting()]; // always run this

        if (!state) {
          promises.push(getRequestDetail()); // run only if state is not provided
        } else {
          setPaymentRequestDetails(state); // use state directly
        }

        await Promise.all(promises); // wait for all
      } catch (error) {
        console.error("Error loading data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return <CircularLoader />;
  }

  return (
    <Elements stripe={loadStripe(key)}>
      <PendingRequests paymentRequest={paymentRequestDetails} />
    </Elements>
  );
}
